// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"home__wrapper--5Hh3G"};